import { EStudentCalendarEventType } from '@constants';
import { IEventByType, IUser } from '@sdk/contracts';
import { dateProvider } from '@utils';

export const getColorType = (event: IEventByType, profile: IUser) => {
  if (dateProvider.isBefore(event.startDate.dateTime, dateProvider.now())) {
    if (
      !event.conferenceData?.insights?.participants &&
      !event.conferenceData?.insights?.recordedParticipants
    ) {
      return EStudentCalendarEventType.NOT_VIEWED;
    }
    if (
      event.conferenceData?.insights?.participants?.some(
        participant => participant.user._id === profile._id
      ) ||
      event.conferenceData?.insights?.recordedParticipants?.some(
        participant => participant.user._id === profile._id
      )
    ) {
      return EStudentCalendarEventType.VIEWED;
    } else {
      return EStudentCalendarEventType.NOT_VIEWED;
    }
  }
  return EStudentCalendarEventType.DEFAULT;
};
